import request from "./request";

const requestAll = (urls, query = "") =>
  urls.map((url) => request.get(`/v1/${url}${query && `/?per_page=${query}`}`));

const getSigBidang = (query = "") =>
  request.get(`/v1/sig/stream/?filter{tipe.nama}=bidang${query}`);
export { requestAll, getSigBidang };
